module.exports = __webpack_public_path__ + "static/media/6.18.4b3e3135.png";